import React from 'react';
import Checkit from 'checkit';
import { SubmissionError } from 'redux-form';

export const validateAndDispatch = (dispatch, action, validation, values) => {
  // console.log('trying validation');
  const checkit = validation instanceof Checkit ? validation : new Checkit(validation);
  // console.log('after. now trying promise');

  return new Promise((resolve, reject) => {
    // console.log('values', values);
    return checkit.run(values).then((validated) => {
      // console.log('validated');
      dispatch(action).then((result) => {
        if (result.error && result.error.json && result.error.json.errors) {
          // console.log('1st err', result, result.error.json.errors);
          reject(new SubmissionError(result.error.json.errors));
        } else if (result.error) {
          // console.log('2nd err', result.error);
          reject(new SubmissionError(result.error));
        } else {
          // console.log('result', result);
          resolve(result);
        }
      });
    }).catch((err) => {
      console.log('catch', err, typeof err);
      reject(new SubmissionError(err.toJSON()));
    });
  });
};

export const spinner = (submitting) => {
  if (!submitting) return null;
  return <i className="fa fa-spinner fa-spin"></i>;
};



// WEBPACK FOOTER //
// ./src/helpers/form.js